<div class="popular-tracks">
    <div class="title" trans>Popular Songs</div>
    <track-list [dataSource]="datatable" [queueItemId]="artistQueueId" [showHeader]="false"></track-list>
    <button class="no-style dark-button" (click)="togglePopularTracksCount()">
        <span *ngIf="visibleTrackCount === 5" trans>Show More</span>
        <span *ngIf="visibleTrackCount !== 5" trans>Show Less</span>
    </button>
</div>
